import IconProvider from './IconProvider.vue';

export default IconProvider;
